import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
/* eslint-disable*/
const Header = () => {
  return (
    <HeaderRoot className="header_layout_1">
      <div className="kr_nike" id="inputFocusOutPosition">
        <div className="pre_header" data-preheader-area="">
          <div className="nk_brand">
            <ul className="pre-brand-menu d-sm-h d-md-flx">
              <li className="pre-brand-item d-sm-ib prl3-sm">
                <a
                  data-click-area="Upper GNB"
                  data-click-name="jordan"
                  data-global-click-area="global-nav"
                  data-global-click-name="Brand Bar"
                  data-global-click-activity="Jordan"
                  href="https://www.nike.com/kr/ko_kr/l/jordan">
                  <svg height="24px" width="24px" fill="#111" viewBox="0 0 26 32">
                    <path d="M14.4 5.52v-.08q0-.56.36-1t.92-.44 1 .36.48.96-.36 1-.96.4l-.24.08.08.12-.08.44-.16 1.28q.08.08.08.16l-.16.8q-.08.16-.16.24l-.08.32q-.16.64-.28 1.04t-.2.64V12q-.08.4-.12.64t-.28.8q-.16.32 0 1.04l.08.08q0 .24.2.56t.2.56q.08 1.6-.24 2.72l.16.48q.96.48.56 1.04l.4.16q.96.48 1.36.84t.8.76q.32.08.48.24l.24.08q1.68 1.12 3.36 2.72l.32.24v.08l-.08.16.24.16h.08q.24.16.32.16h.08q.08 0 .16-.08l.16-.08q.16-.16.32-.24h.32q.08 0 0 .08l-.32.16-.4.48h.56l.56.08q.24-.08.4-.16l.4-.24q.24-.08.48.16h.08q.08.08-.08.24l-.96.88q-.4.32-.72.4l-1.04.72q-.08.08-.16 0l-.24-.32-.16-.32-.2-.28-.24-.32-.2-.24-.16-.2-.32-.24q-.16 0-.32-.08l-1.04-.8q-.24 0-.56-.24-1.2-1.04-1.6-1.28l-.48-.32-.96-.16q-.48-.08-1.28-.48l-.64-.32q-.64-.32-.88-.32l-.32-.16q-.32-.08-.48-.16l-.16-.16q-.16 0-.32.08l-1.6.8-2 .88q-.8.64-1.52 1.04l-.88.4-1.36.96q-.16.16-.32 0l-.16.16q-.24.08-.32.08l-.32.16v.16h-.16l-.16.24q-.16.32-.32.36t-.2.12-.08.12l-.16.16-.24.16-.36-.04-.48.08-.32.08q-.4.08-.64-.12t-.4-.6q-.16-.24.16-.4l.08-.08q.08-.08.24-.08h.48L1.6 26l.32-.08q0-.16.08-.24.08-.08.24-.08v-.08q-.08-.16-.08-.32-.08-.16-.04-.24t.08-.08h.04l.08.24q.08.4.24.24l.08-.16q.08-.16.24-.16l.16.16.16-.16-.08-.08q0-.08.08-.08l.32-.32q.4-.48.96-.88 1.12-.88 2.4-1.36.4-.4.88-.4.32-.56.96-1.2.56-.4.8-.56.16-.32.4-.32H10l.16-.16q.16-.08.24-.16v-.4q0-.4.08-.64t.4-.24l.32-.32q-.16-.32-.16-.72h-.08q-.16-.24-.16-.48-.24-.4-.32-.64h-.24q-.08.24-.4.32l-.08.16q-.32.56-.56.84t-.88.68q-.4.4-.56.88-.08.24 0 .48l-.08.16h.08q0 .16.08.16h.08q.16.08.16.2t-.24.08-.36-.16-.2-.12l-.24.24q-.16.24-.32.2t-.08-.12l.08-.08q.08-.16 0-.16l-.64.16q-.08.08-.2 0t.04-.16l.4-.16q0-.08-.08-.08-.32.16-.64.08l-.4-.08-.08-.08q0-.08.08-.08.32.08.8-.08l.56-.24.64-.72.08-.16q.32-.64.68-1.16t.76-.84l.08-.32q.16-.32.32-.56t.4-.64l.24-.32q.32-.48.72-.48l.24-.24q.08-.08.08-.24l.16-.16-.08-.08q-.48-.4-.48-.72-.08-.56.36-.96t.88-.36.68.28l.16.16q.08 0 .08.08l.32.16v.24q.16.16.16.24.16-.24.48-.56l.4-1.28q0-.32.16-.64l.16-.24v-.16l.24-.96h.16l.24-.96q.08-.24 0-.56l-.32-.8z"></path>
                  </svg>
                  {/* <h3>TEST</h3> */}
                </a>
              </li>
              <li className="pre-brand-item d-sm-ib prl3-sm">
                <a
                  href="https://www.converse.co.kr"
                  target="_blank"
                  rel="noreferrer"
                  data-click-area="Upper GNB"
                  data-click-name="converse"
                  data-global-click-area="global-nav"
                  data-global-click-name="Brand Bar"
                  data-global-click-activity="Converse">
                  <svg height="24px" width="24px" fill="#111" viewBox="0 0 39 33">
                    <path d="M10.94 25.626l-4.236-5.501L.201 22.28l3.734-5.756L.11 10.777l6.59 2.031 4.026-5.474.14 6.785 6.64 2.175-6.594 2.446.028 6.886zm.824 7.239l13.952-16.393L11.806.107h11.697l14.871 16.389-14.8 16.369h-11.81z"></path>
                  </svg>
                </a>
              </li>
              <li id="jq_m_right_click"></li>
            </ul>
            <div className="desk_user" data-user-area="">
              <ul>
                <li>
                  <a
                    data-click-area="Upper GNB"
                    data-click-name="서포트_고객센터"
                    data-global-click-area="global-nav"
                    data-global-click-name="Membership"
                    data-global-click-activity="customer center"
                    href="https://nike-breeze.zendesk.com">
                    Help
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="header">
          <div className="pre_nav_box">
            <div className="nk_gnb">
              <ul>
                <li>
                  <a
                    style={{
                      fontWeight: 500,
                      fontFamily: '"Helvetica Neue", Helvetica, "Noto Sans KR", Arial, sans-serif',
                      letterSpacing: '0',
                    }}
                    href="https://www.nike.com/kr/ko_kr/w/xg/xb/xc/new-releases">
                    New Releases
                  </a>
                </li>
                <li>
                  <a
                    style={{
                      fontWeight: 500,
                      fontFamily: '"Helvetica Neue", Helvetica, "Noto Sans KR", Arial, sans-serif',
                      letterSpacing: '0',
                    }}
                    href="https://www.nike.com/kr/ko_kr/l/men">
                    Men
                  </a>
                </li>
                <li>
                  <a
                    style={{
                      fontWeight: 500,
                      fontFamily: '"Helvetica Neue", Helvetica, "Noto Sans KR", Arial, sans-serif',
                      letterSpacing: '0',
                    }}
                    href="https://www.nike.com/kr/ko_kr/l/women">
                    Women
                  </a>
                </li>
                <li>
                  <a
                    style={{
                      fontWeight: 500,
                      fontFamily: '"Helvetica Neue", Helvetica, "Noto Sans KR", Arial, sans-serif',
                      letterSpacing: '0',
                    }}
                    href="https://www.nike.com/kr/ko_kr/l/kids">
                    Kids
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.nike.com/kr/ko_kr/c/nike-membership"
                    style={{
                      fontWeight: 500,
                      fontFamily: '"Helvetica Neue", Helvetica, "Noto Sans KR", Arial, sans-serif',
                      letterSpacing: '0',
                      color: '#e90606',
                    }}>
                    Member Days
                  </a>
                </li>
              </ul>
            </div>
            <div className="nk_slide">
              <h1>
                <span style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.nike.com/kr/ko_kr/')}>
                  <img src="../static/images/icon/logo.png" width="60px" height="28px" />
                </span>
              </h1>
              <MobileMenuButton>
                <button
                  data-var="mobileButton"
                  onClick={() => {
                    document.getElementById('mobileSideMenu').style.display = 'block';
                  }}>
                  <svg width="24px" height="24px" fill="#111" viewBox="0 0 24 24">
                    <path d="M21 13H3c-.6 0-1-.4-1-1s.4-1 1-1h18c.6 0 1 .4 1 1s-.4 1-1 1zm0-8H3c-.6 0-1-.4-1-1s.4-1 1-1h18c.6 0 1 .4 1 1s-.4 1-1 1zm0 16H3c-.6 0-1-.4-1-1s.4-1 1-1h18c.6 0 1 .4 1 1s-.4 1-1 1z"></path>
                  </svg>
                </button>
              </MobileMenuButton>
            </div>
            <MobileMenu id="mobileSideMenu">
              <div className="mobile_menu open" data-mobilemenu-area="">
                <div className="mobile_menu_inner" data-mobilemenuinner-area="">
                  <div className="mob_gnb">
                    <ul className="next_pnl" data-container-mobile-menu="">
                      <li>
                        <a
                          data-mobile-nextdepth=""
                          data-click-area="GNB"
                          data-click-enable="true"
                          data-click-name="New Releases>"
                          href="https://www.nike.com/kr/ko_kr/w/xg/xb/xc/new-releases"
                          className="next_depth">
                          New Releases
                        </a>
                      </li>
                      <li>
                        <a
                          data-mobile-nextdepth=""
                          data-click-area="GNB"
                          data-click-enable="true"
                          data-click-name="Men>"
                          href="https://www.nike.com/kr/ko_kr/l/men"
                          className="next_depth">
                          Men
                        </a>
                      </li>
                      <li>
                        <a
                          data-mobile-nextdepth=""
                          data-click-area="GNB"
                          data-click-enable="true"
                          data-click-name="Women>"
                          href="https://www.nike.com/kr/ko_kr/l/women"
                          className="next_depth">
                          Women
                        </a>
                      </li>
                      <li>
                        <a
                          data-mobile-nextdepth=""
                          data-click-area="GNB"
                          data-click-enable="true"
                          data-click-name="Kids>"
                          href="https://www.nike.com/kr/ko_kr/l/kids"
                          className="next_depth">
                          Kids
                        </a>
                      </li>
                      <li>
                        <a
                          data-mobile-nextdepth=""
                          data-click-area="GNB"
                          data-click-enable="true"
                          data-click-name="Member Days 사전 참여"
                          href="https://www.nike.com/kr/ko_kr/c/nike-membership"
                          style={{ color: '#e90606' }}
                          className="link">
                          Member Days
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="dimd"
                onClick={() => {
                  document.getElementById('mobileSideMenu').style.display = 'none';
                }}></div>
            </MobileMenu>
          </div>
        </div>
      </div>
    </HeaderRoot>
  );
};

const HeaderRoot = styled.header`
  ul {
    list-style: none;
  }
  a {
    color: black;
    text-decoration: none;
  }
  .pre_header {
    padding: 4px 42px;
    background: #f4f4f4;
    .nk_brand {
      display: flex;
      justify-content: space-between;
    }
    .pre-brand-menu {
      display: flex;
      li {
        margin-right: 8px;
      }
    }
  }
  .header {
    height: 60px;
    position: relative;
    margin: 0 42px;
    h1 {
      position: absolute;
      top: 0;
    }
    .nk_gnb {
      padding-top: 25px;
      ul {
        display: flex;
        column-gap: 24px;
        justify-content: center;
      }
    }
    .nk_slide {
      display: flex;
      justify-content: space-between;
    }
    margin-bottom: 20px;
  }

  @media only screen and (max-width: 768px) {
    .pre_header {
      padding: 4px 24px;
    }
    .header {
      margin: 0 24px;
      height: 56px;
      .nk_gnb {
        display: none;
      }
      h1 {
        position: unset;
        img {
          padding: 16px 0;
          position: absolute;
          top: 0;
        }
      }
    }
  }
`;
const Container = styled.div`
  &.left__container {
  }
  &.right__container {
  }
`;
const MobileMenu = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  z-index: 10;
  display: none;
  @media only screen and (max-width: 768px) {
    display: none;
  }
  .mobile_menu {
    position: absolute;
    overflow-x: hidden;
    top: 0;
    right: 0;
    height: 100vh;
    background-color: #fff;
    width: 320px;
  }
  .mobile_menu_inner {
    position: absolute;
    right: 0;
    left: 0;
    padding: 0 36px 150px;
    margin-top: 46px;
    transform: translateX(0);
    transition: transform 0.25s;
  }
  .next_pnl {
    font-weight: 500;
    font-size: 24px;
    li {
      padding: 10px 0;
    }
  }
  .dimd {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    opacity: 1;
  }
`;
const MobileMenuButton = styled.div`
  padding-top: 16px;
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;
Header.propTypes = {};

export default Header;
